export default "__VITE_ASSET__DNov$hYw__"